import { render } from "./MobileSidebar.vue?vue&type=template&id=5efa6e6f"
import script from "./MobileSidebar.vue?vue&type=script&lang=js"
export * from "./MobileSidebar.vue?vue&type=script&lang=js"

import "./MobileSidebar.vue?vue&type=style&index=0&id=5efa6e6f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__